import Emitter from "./Emitter";

export default class GameAutoplayStart extends Emitter {
    constructor(gb) {
        super(gb);
    }

    POKERSTARS_handler() {
        const dataForXc = {
            "msgId": "rg2xcGameStatusUpdated",
            "status": "autoPlayStart",
        }

        if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
            window.parent.postMessage(JSON.stringify(dataForXc), this.gb.api.settings.pokerstarsOrigin);
        } else {
            window.parent.postMessage(JSON.stringify(dataForXc), "*");
        }
    }

    PLAYTECH_handler() {
        if (this.gb.ptResFeat && this.gb.ptResFeat.includes('autoplay')) {
            let data = {_type: "ucip.autoplay.g2wAutoplayStartNotification"};
            if (this.gb.settings.nativeMobileApp) {
                data.handled = true;
                window.parent.postMessage(JSON.stringify(data));
            } else {
                this.emitParent(JSON.stringify(data));
            }
        }
    }

    _default() {
        this.emitTop({ wpgaction: "autoplayStart" });
        this.emitParent({ wpgaction: "autoplayStart.parent" });
        this.emitiOS({ wpgaction: "autoplayStart" });
    }
}
